/* eslint-disable no-unused-vars */
/* global G */
import asObject from 'lib/sequence/component/children/asObject'
import find from 'lib/sequence/component/children/find'
import { checked } from 'lib/sequence/component/state/checked'
import { hide, show } from 'lib/sequence/component/state/hidden'
import { asyncPipeSpread, bulk } from 'lib/util'
import initAddress from 'app/_shared/action/address/init'
import displayState from 'app/_shared/events/address/displayState'
import displayHouseNumber from 'app/_shared/events/address/displayHouseNumber'
import { settings } from 'app/_shared/session'

const bulkShow = bulk(show)
const bulkHide = bulk(hide)

const initOrganisationAddress = initAddress(
  { component: 'country' },
  { attribute: 'requesterOrg' },
)

/**
 * Controls the display of the `supportedBy` field
 *
 * @param {Object} module the ticket module composition object
 * @returns {function(*): function(*, ...[*]): Promise<*[]>}
 */
const displaySupportedBy = module => component => async (components, ...args) => {
  const { supportedBy, buttons } = asObject(component[G.CHILDREN])
  const { store } = find(component[G.ACTIONS][0])

  const storeChecked = !settings.suppressSupportedBy && checked(store)
  const toggleVisibility = storeChecked ? bulkShow : bulkHide
  toggleVisibility(supportedBy)

  return args
}

/**
 * Organisation editing and creation.
 *
 * Toggles the visibility and mapping of fields depending on whether the organisation should just be
 * saved for a ticket or as an individual entity in the database and whether there is already an
 * entity selected.
 *
 * @param {Object} module the ticket module composition object
 * @returns {function(*): function(...[*]): Promise<*[]>}
 */
export default module => component => async (...args) => asyncPipeSpread(
  initOrganisationAddress(
    displayState('state', 'country'),
    displayHouseNumber('number', 'street'),
  )(module),
  displaySupportedBy(module)(component),
)(find(component), ...args)
